import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";

const SESSION_KEY = "wedding-envelope-intro-seen";

function hasSeenIntro() {
  try {
    return window.sessionStorage.getItem(SESSION_KEY) === "true";
  } catch {
    return false;
  }
}

function markIntroSeen() {
  try {
    window.sessionStorage.setItem(SESSION_KEY, "true");
  } catch {
    // Private browsing settings may make sessionStorage unavailable.
  }
}

export default function EnvelopeIntro() {
  const shouldReduceMotion = useReducedMotion();
  const [isVisible, setIsVisible] = useState(() => !hasSeenIntro());
  const reducedMotion = shouldReduceMotion === true;

  useEffect(() => {
    if (!isVisible) {
      return;
    }

    markIntroSeen();
  }, [isVisible]);

  const dismiss = () => setIsVisible(false);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="envelope-intro"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.55 } }}
          onClick={dismiss}
          role="dialog"
          aria-label="Wedding invitation introduction"
        >
          <button
            className="envelope-close"
            type="button"
            onClick={dismiss}
            aria-label="Close invitation"
          >
            &times;
          </button>

          <div className="envelope-scene">
            <div className="invitation-card-positioner">
              <motion.div
                className="invitation-card"
                initial={reducedMotion ? { opacity: 1, y: -160 } : { opacity: 1, y: 80 }}
                animate={{ opacity: 1, y: -160 }}
                transition={
                  reducedMotion
                    ? { duration: 0 }
                    : { delay: 0.8, duration: 1.35, ease: [0.22, 1, 0.36, 1] }
                }
              >
                <p className="invitation-kicker">A little note for you</p>
                <p className="invitation-title">You&apos;re invited!</p>
                <p className="invitation-message">Come celebrate with us</p>
                <p className="invitation-names">Ryan &amp; Lily</p>
                <p className="invitation-date">August 8, 2027</p>
              </motion.div>
            </div>

            <div className="envelope">
              <div className="envelope-back" />
              <div className="envelope-pocket" />
              <motion.div
                className="envelope-flap"
                initial={{ rotateX: 0 }}
                animate={{ rotateX: -180 }}
                transition={
                  reducedMotion
                    ? { duration: 0 }
                    : { delay: 0.35, duration: 0.95, ease: [0.65, 0, 0.35, 1] }
                }
              />
              <div className="envelope-front" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
